import React, { useState } from "react";
import "./assets/css/App.css";
import banner from "./assets/image/banner-home.png";
import logo from "./assets/image/logo.png";
import cards from "./assets/components/caroussel.js";
import rafael from "./assets/image/rafael.png";
import caio from "./assets/image/caio.png";
import douglas from "./assets/image/douglas.png";
import app from "./assets/image/app.png";
import estrela from "./assets/image/estrela.png";
import unimar from "./assets/image/unimar-logo.png";
import dponet from "./assets/image/logo-dponet.png";
import smart from "./assets/image/smart-services.png";
import sebrae from "./assets/image/sebrae-startups.png";
// import flecha from "./assets/image/flecha.png";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import ai from "./assets/image/ai.png";
import ux from "./assets/image/ux.png";
import segpriv from "./assets/image/seg-priv.png";
import relatorio from "./assets/image/relatorio.png";
import compromisso from "./assets/image/compromisso.png";
import escalabilidade from "./assets/image/escalabilidade.png";
import python from "./assets/image/Python.png";
import bootstrap from "./assets/image/Bootstrap.png";
import postgre from "./assets/image/PostgreSQL.png";
import react from "./assets/image/React.png";
import node from "./assets/image/NodeJS.png";
import cplus from "./assets/image/cplus.png";
import docker from "./assets/image/docker.png";
import flutter from "./assets/image/flutter.png";
import Timeline from "./assets/components/timeline.js";
import NewsCarousel from "./assets/components/newsCarousel";
import persys from "./assets/image/persys.png";
import { Accordion, AccordionItem } from '@szhsin/react-accordion';
import leavening from "./assets/image/leavening.png";
import DepoimentoCard from './assets/components/depoimentoCard.js';
import equipe from "./assets/image/equipe.png";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "none" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "none" }}
      onClick={onClick}
    />
  );
}

const LandingPage = () => {
  const [selectedCard, setSelectedCard] = useState(0);
  const [selectedDepoimento, setSelectedDepoimento] = useState(1);
  const partners = [dponet, persys, unimar, leavening, smart, sebrae];
  const depoimentos = [{
    nome: "Douglas Rodrigues",
    imagem: douglas,
    cargo: "Mestre e Doutor",
    texto: "A GaekWare oferece uma solução inovadora de registro de ponto com reconhecimento facial, tornando o processo mais rápido e seguro, além de fornecer dados analíticos úteis para as instituições. Uma excelente opção para modernizar a gestão educacional!"
  },
  {
    nome: "Rafael Castanha",
    imagem: rafael,
    cargo: "Mestre e Doutor",
    texto: "Como consultor acadêmico, recomendo as soluções da GaekWare por sua precisão e capacidade de integração com sistemas educacionais existentes."
  },
  {
    nome: "Caio Coneglian",
    imagem: caio,
    cargo: "Coordenador Unimar",
    texto: "A parceria com a GaekWare transformou nosso controle de frequência, reduzindo em 80% o tempo gasto com processos manuais."
  },
  ];
  const estrelas = [estrela, estrela, estrela, estrela, estrela]

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: "0px",
    slidesToScroll: 1,
    autoplay: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div>
      {/* Navbar */}
      <nav>
        <div>
          <a href="/">
            <img src={logo} alt="Logo" />
          </a>
        </div>
        {/* <button className="client">Área do Cliente</button> */}
      </nav>

      {/* Hero Section */}
      <header>
        <div className="banner-esquerda">
          <h1>
            <span className="font-straight">
              Ótimos <span className="text-blue">softwares</span> são
            </span>
            <br /> <span className="font-bold">
              {" "}
              <span>construídos por</span>
              <br /> grandes <span className="text-blue"> equipes</span>
            </span>
            .
          </h1>
          <p>
            E claro... estamos em busca de transformar a{" "}
            <span className="font-bold">educação</span>, e conectar dados para
            um <span className="font-bold">futuro melhor</span>.
          </p>
          {/* <button className="vamos-la">Vamos lá!</button> */}
        </div>
        <div className="img-principal-container">
          <img className="img-principal" src={banner} alt="Ilustração" />
        </div>
      </header>

      {/* Cards Section - Carrossel */}
      <section className="card-container-counter">
        <div className="card-wrapper">
          <div className="card-container">
            {cards.map((card, index) => (
              <div
                key={index}
                className={`card ${selectedCard === index ? "selected" : ""}`}
                onClick={() => setSelectedCard(index)}
              >
                <img src={card.icon} alt={card.title} width={50} height={50} />
                <h3>{card.title}</h3>
                <p>{card.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="progress-container">
          {/* Bolinhas centralizadas */}
          <div className="dots-container">
            {cards.map((_, index) => (
              <span
                key={index}
                className={`dot ${selectedCard === index ? "active" : ""}`}
                onClick={() => setSelectedCard(index)}
              ></span>
            ))}
          </div>
        </div>

        {/* Barra de progresso à direita + contador */}
        <div className="progress-wrapper">
          <span className="counter">
            {String(selectedCard + 1).padStart(2, "0")}
          </span>
          <div className="progress-line">
            <div
              className="progress-bar"
              style={{ width: `${((selectedCard + 1) / cards.length) * 100}%` }}
            ></div>
          </div>
          <span className="counter">
            {String(cards.length).padStart(2, "0")}
          </span>
        </div>
      </section>

      {/* História Startup */}
      <section className="history-startup">
        <div className="text-content">
          <h1>
            <span className="font-straight">
              Por trás de toda startup,
              <br />
              <span className="font-bold">existe uma história.</span>
            </span>
          </h1>
          <p>
            Por trás de toda startup, há uma história de desafios, inovação e perseverança.
            Cada ideia nasce para resolver um problema e se torna realidade graças à dedicação
            de empreendedores que enfrentam obstáculos e transformam incertezas em oportunidades.
            Mais do que tecnologia, startups são movidas por pessoas apaixonadas em fazer a diferença.
            <br />
            Nesta imagem está a equipe da GaekWare, composta por estudantes de ciência da computação
            da Unimar, que se uniram para criar soluções inovadoras e impactantes no setor educacional, e isso vem de um sonho que começou em 2023, quando decidimos transformar nossa ideia em realidade.
          </p>
          {/* <a href="/" className="more-info">Veja mais informações ➔</a> */}
        </div>
        <div className="image-content">
          <img src={equipe} alt="Equipe de Startup" className="rounded-image" />
        </div>
      </section>

      {/* Seção de Apoiadores */}
      <section className="apoiadores">
        <h2>
          <span className="font-straight">Conheça nossos</span>
          <br />
          <span className="font-bold">Parceiros e Apoiadores</span>
        </h2>
        <div className="supporter-carousel">
          <Slider {...sliderSettings}>
            {partners.map((partner, index) => (
              <div key={index}>
                <img src={partner} alt={`Partner ${index}`} className="partner-logo" />
              </div>
            ))}
          </Slider>
        </div>
      </section>
      <section className="depoimentos">
        <div className="box-depoimento">
          <div className="titulo-depoimento">
            <h2>
              <span className="font-straight">O que estão falando da</span>
              <br />
              <span className="font-bold">GaekWare?</span>
            </h2>
          </div>

          <div className="frase-depoimento">
            <p>{depoimentos[selectedDepoimento].texto}</p>
          </div>

          <div className="texto-depoimento">
            {depoimentos.map((depoimento, index) => (
              <DepoimentoCard
                key={index}
                depoimento={depoimento}
                estrelas={estrelas}
                ativo={selectedDepoimento === index}
                onClick={() => setSelectedDepoimento(index)}
              />
            ))}
          </div>
        </div>
      </section>
      <section className="desenvolvimento">
        <div className="titulo-desenvolvimento">
          <h2>
            <span className="font-straight">O que estamos</span>
            <br />
            <span className="font-bold">Desenvolvendo</span>
          </h2>
        </div>
        <div className="conteudo-desenvolvimento">
          <img src={app} alt={"Imagem App"} className="imagem-app" />
          <div className="unirecognition">
            <h1>Uni Recognition</h1>
            <br></br>
            <p>O Uni Recognition é um projeto inovador que utiliza a tecnologia de reconhecimento facial para automatizar o processo de marcação de presença em ambientes acadêmicos, empregando câmeras estrategicamente posicionadas para identificar instantaneamente os estudantes e registrar suas presenças, eliminando a burocracia e permitindo que professores e funcionários se concentrem em atividades mais produtivas, além de oferecer recursos avançados de gestão e acompanhamento acadêmico.</p>
            {/* <div className="div-saiba-mais">
              <a href="/" className="degrade-azul">Saiba mais</a>
              <a href="/"><img src={flecha} alt={"flecha"} className="flecha" /></a>
            </div> */}
          </div>
        </div>
        {/* <div className="proximos-projetos">
          <a href="/" className="degrade-azul">Veja os próximos projetos</a>
          <a href="/"><img src={flecha} alt={"flecha"} className="flecha-projetos" /></a>
        </div> */}
      </section>
      <section className="diferencial-startup">
        <div className="titulo-diferencial">
          <h2>
            <span className="font-straight">Qual o nosso</span>
            <br />
            <span className="font-bold">diferencial como startup?</span>
          </h2>
        </div>
        <div className="diferencial-container">
          <div class="parent">
            <div class="card-diferencial">
              <img src={ai} alt="Imagem" class="img-pequena" />
              <div class="texto">
                <h2>Inteligência artificial</h2>
                <p>Utilizamos reconhecimento facial e inteligência artificial para automatizar o controle de chamada, garantindo um processo mais rápido, preciso e livre de fraudes, tornando a gestão acadêmica mais eficiente.</p>
              </div>
            </div>
            <div class="card-diferencial">
              <img src={ux} alt="Imagem" class="img-pequena" />
              <div class="texto">
                <h2>Experiência do Usuário (UX)</h2>
                <p>Nosso sistema foi desenvolvido com um design intuitivo e acessível, proporcionando uma experiência fluida para alunos, professores e gestores, facilitando o uso sem a necessidade de treinamentos complexos.</p>
              </div>
            </div>
            <div class="card-diferencial">
              <img src={segpriv} alt="Imagem" class="img-pequena" />
              <div class="texto">
                <h2>Segurança e Privacidade</h2>
                <p>Priorizamos a proteção dos dados com criptografia avançada, armazenamento seguro e conformidade com normas de privacidade, garantindo total segurança e transparência para instituições e usuários.</p>
              </div>
            </div>
            <div class="card-diferencial">
              <img src={relatorio} alt="Imagem" class="img-pequena" />
              <div class="texto">
                <h2>Relatórios Inteligentes</h2>
                <p>Oferecemos relatórios detalhados e personalizados, permitindo que gestores acadêmicos tomem decisões estratégicas com base em dados precisos sobre frequência, desempenho e engajamento dos alunos.</p>
              </div>
            </div>
            <div class="card-diferencial">
              <img src={compromisso} alt="Imagem" class="img-pequena" />
              <div class="texto">
                <h2>Compromisso com a Educação</h2>
                <p>Nosso foco é transformar a gestão acadêmica, reduzindo processos manuais e burocráticos para que professores e coordenadores possam dedicar mais tempo ao ensino e ao acompanhamento dos alunos.</p>
              </div>
            </div>
            <div class="card-diferencial">
              <img src={escalabilidade} alt="Imagem" class="img-pequena" />
              <div class="texto">
                <h2>Escalabilidade e Integração</h2>
                <p>O UniRecognition é flexível e escalável, se adaptando a instituições de diferentes portes. Além disso, permite integração com sistemas acadêmicos já existentes, facilitando sua implementação sem complicações.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="tecnologia-dia-a-dia">
        <div className="titulo-diferencial">
          <h2>
            <span className="font-straight">Tecnologias do nosso</span>
            <br />
            <span className="font-bold">dia a dia</span>
          </h2>
        </div>
        <div class="grid-imagens">
          <img src={node} alt="Imagem 1" />
          <img src={bootstrap} alt="Imagem 2" />
          <img src={postgre} alt="Imagem 3" />
          <img src={react} alt="Imagem 4" />
          <img src={python} alt="Imagem 5" />
          <img src={cplus} alt="Imagem 2" />
          <img src={docker} alt="Imagem 3" />
          <img src={flutter} alt="Imagem 4" />
        </div>
      </section>
      <section className="timeline-section">
        <div className="titulo-diferencial">
          <h2>
            <span className="font-straight">Nossa</span>
            <br />
            <span className="font-bold">trajetória</span>
          </h2>
        </div>
        <div className="timeline">
          <Timeline />
        </div>
      </section>
      <section className="anda-rolando">
        <div className="titulo-rolando">
          <h2>
            <span className="font-straight">O que anda rolando</span>
            <br />
            <span className="font-straight">pela </span>
            <span className="font-bold">GaekWare?</span>
          </h2>
        </div>

        <NewsCarousel />

      </section>

      <div className="titulo-rolando">
        <h2>
          <span className="font-straight">FAQ</span>
          <br />
          <span className="font-bold">Perguntas Frequentes</span>
        </h2>
      </div>

      <Accordion>
        <AccordionItem header="O que é a GaekWare?" initialEntered>
          A GaekWare é uma startup de tecnologia que busca otimizar o registro de presenças em ambientes educacionais por meio de identificação facial e detecção de dispositivos via Wi-Fi/Bluetooth.
        </AccordionItem>

        <AccordionItem header="Como funciona o sistema da GaekWare?">
          O sistema utiliza um módulo ESP32 para capturar endereços MAC de dispositivos próximos e enviá-los a um servidor em nuvem. Além disso, está sendo desenvolvido a integração com reconhecimento facial para aumentar a precisão da identificação.
        </AccordionItem>

        <AccordionItem header="Como a GaekWare garante a segurança dos dados coletados?">
          A equipe está adotando boas práticas de segurança na transmissão e armazenamento de dados, além de seguir regulamentações de privacidade para garantir a proteção das informações dos usuários, tendo também como base sólida a LGPD.
        </AccordionItem>

        <AccordionItem header="Em que estágio de desenvolvimento o projeto está atualmente?">
          O sistema já consegue capturar endereços MAC e enviá-los ao servidor. Os próximos passos incluem refinar a precisão da detecção, integrar o reconhecimento facial, testar em ambiente real e desenvolver uma interface intuitiva.
        </AccordionItem>

        <AccordionItem header="Quem pode utilizar a solução da GaekWare?">
          Inicialmente, a solução está sendo desenvolvida para universidades e instituições de ensino superior, mas futuramente poderá ser adaptada para outras instituições educacionais.
        </AccordionItem>

        <AccordionItem header="Como entrar em contato com a equipe da GaekWare?">
          Interessados podem entrar em contato por meio dos canais oficiais da startup localizados ao fim da página.
        </AccordionItem>
      </Accordion>

      <section className="entre-em-contato">
        <div className="box-contato">
          <div className="texto-entre-contato">
            <h2>Entre em contato conosco!</h2>
          </div>
          <a href="mailto:contato@gaekware.com" className="botao-contato">
            <span className="texto-contato">Contato</span>
          </a>
        </div>
      </section>
      <section className="footer-section">
        <footer className="footer-container">
          <div className="footer-column">
            <div className="footer-logo">
              <img src={logo} alt="Logo" className="logo-img" />
            </div>
            <button className="privacy-button">Política de Privacidade</button>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">Links</h3>
            <div className="footer-links">
              <a href="/" className="footer-link">Sobre nós</a>
              <a href="/" className="footer-link">Serviços</a>
              <a href="/" className="footer-link">Nossos clientes</a>
            </div>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">Contato</h3>
            <a href="mailto:contato@gaekware.com" className="footer-email">
              contato@gaek.com.br
            </a>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">Redes sociais</h3>
            <div className="social-icons">
              <a href="https://www.linkedin.com/company/gaekware/" className="social-icon-circle">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="https://www.instagram.com/gaekware" className="social-icon-circle">
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.tiktok.com/@gaekware" className="social-icon-circle">
                <i className="fab fa-tiktok"></i>
              </a>
            </div>
          </div>
        </footer>
      </section>
    </div>
  );
};

export default LandingPage;
